@if (component) {
<div [class._is-compact]="component.compact">
    <div [ngClass]="component.ratio || 'ratio-1-1'">
        <shell></shell>
        @if (component.image) {
        <img class="rf z-1"
             [image]="component.image">
        }
        <div class="fill flex z-2"
             [ngClass]="'flex-' + component.verticalAlignment">
            <href [link]="isActive ? component.link : component.linkAfterCountdown || component.link"
                  class="w-12 pos-absolute z-3 flex"
                  [ngClass]="['flex-justify-' + component.horizontalAlignment, component.horizontalAlignment, component.compact ? 'm-t-3 m-b-3 p-r-6-l p-r-3-s p-l-6-l p-l-3-s' : 'm-t-10 m-b-10 p-r-10-l p-r-4-s p-l-10-l p-l-4-s']">
                <div class="wrap-x wrap-m">
                    @switch (isActive) {
                    @case (true) {
                    <h6 [ngClass]="[component.titleColor || 'col-w', component.titleStyle || 'h1', component.compact ? 'p-b-2' : 'p-b-7 p-b-5-m p-b-5-s']"
                        *iCms="'title' of component; skipEmpty: true; content: 'html'"></h6>
                    <p [ngClass]="[component.subtitleColor || 'col-w', component.subtitleStyle || 'h2']"
                       *iCms="'subtitle' of component; skipEmpty: true;  content: 'html'"></p>
                    }
                    @default {
                    <h6 [ngClass]="[component.textStyleAfterCountdown || 'h1', component.textColorAfterCountdown || 'col-w', component.compact ? 'p-b-2' : 'p-b-7 p-b-5-m p-b-5-s']"
                        *iCms="'textAfterCountdown' of component; skipEmpty: true; content: 'html'"></h6>
                    <p [ngClass]="[component.subtitleColorAfterCountdown || 'col-w', component.subtitleStyleAfterCountdown || 'h2']"
                       *iCms="'subtitleAfterCountdown' of component; skipEmpty: true;  content: 'html'"></p>
                    }
                    }
                    <!-- countdown -->
                    <countdown class="w-12"
                               [class.ng-hide]="!isActive"
                               [ngClass]="component.compact ? 'm-t' : 'm-t-8 m-t-4-m m-t-4-s'"
                               [shouldPad]="true"
                               [date]="component.endDate"
                               [whitelist]="['days', 'hours', 'minutes', 'seconds']"
                               (isActive)="isActiveHandle($event)">
                        <ng-template #countdownTemplate
                                     let-result>
                            <div class="inline-flex m-t-2-m m-t-2-s"
                                 [ngClass]="component.countdownTextColor || 'col-1'">
                                <div class="flex-column flex-middle m-r-2">
                                    <div class="inline-block col-1 _countown-item"
                                         [ngClass]="[component.countdownStyle || 'h1', component.countdownColor || 'col-1']">
                                        @if (result.score?.days >= 1 && result.score?.days < 10)
                                          {
                                          <span>0</span>
                                            }{{result.score?.days || '00'}}
                                    </div>
                                    <div class="c1">{{'Days' | translate}}</div>
                                </div>
                                <div class="flex-column flex-middle m-r-2">
                                    <div class="inline-block col-1 _countown-item"
                                         [ngClass]="[component.countdownStyle || 'h1', component.countdownColor || 'col-1']">
                                        {{result.score?.hours || '00'}}
                                    </div>
                                    <div class="c1">{{'Hrs' | translate}}</div>
                                </div>
                                <div class="flex-column flex-middle m-r-2">
                                    <div class="inline-block col-1 _countown-item"
                                         [ngClass]="[component.countdownStyle || 'h1', component.countdownColor || 'col-1']">
                                        {{result.score?.minutes || '00'}}
                                    </div>
                                    <div class="c1">{{'Mins' | translate}}</div>
                                </div>
                                <div class="flex-column flex-middle m-r-2">
                                    <div class="inline-block col-1 _countown-item"
                                         [ngClass]="[component.countdownStyle || 'h1', component.countdownColor || 'col-1']">
                                        {{result.score?.seconds || '00'}}
                                    </div>
                                    <div class="c1">{{'Secs' | translate}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </countdown>
                    @switch (isActive) {
                    @case (true) {
                    @if (component.ctaText) {
                    <button class="m-t"
                            [ngClass]="component.ctaStyle || 'button'">
                        <span *iCms="'ctaText' of component"></span>
                    </button>
                    }
                    }
                    @default {
                    @if (component.ctaTextAfterCountdown) {
                    <button class="m-t"
                            [ngClass]="component.ctaStyleAfterCountdown || 'button'">
                        <span *iCms="'ctaTextAfterCountdown' of component"></span>
                    </button>
                    }
                    }
                    }
                </div>
            </href>
        </div>
    </div>

    <text-overlay [data]="component" />
</div>
}